import * as z from 'zod';
import { GetParamsSchema } from './shared';
import { axiosInstance } from '@vl-core/api';
import { safeParse } from './helpers/safeParse';

export const path = 'admin/speccats';

const CatSchema = z.object({
  cat_code: z.string(),
  cat_name: z.string(),
  enabled: z.coerce.boolean(),
  no_users: z.number(),
  no_areas: z.number(),
  needs_card_details: z.coerce.boolean(),
  standard_subspecialty: z.union([z.string(), z.null()])
});

export type Cat = z.infer<typeof CatSchema>;

export const ResponseSchema = z.object({
  cats: z.array(CatSchema),
  status: z.number()
});

export type Response = z.infer<typeof ResponseSchema>;

export const ParamsSchema = GetParamsSchema.extend({
  admin_guid: z.string(),
  pat_guid: z.string(),
  enabled: z.union([z.boolean(), z.number()]).optional(),
  see_all: z.boolean().optional(),
  slots: z.union([z.boolean(), z.number()]).optional(),
  self_book: z.union([z.boolean(), z.number(), z.null()]).optional()
});

export type Params = z.infer<typeof ParamsSchema>;

export const getAdminSpecCats = async (params: Params): Promise<Response> => {
  const { admin_guid, ...queryParams } = params;
  const fullPath = `${path}/${admin_guid}`;

  return axiosInstance.get(fullPath, { params: queryParams }).then((res) => ({
    cats: safeParse(res.data, z.array(CatSchema)),
    status: res.status
  }));
};
